import Cookies from 'js-cookie';
// 时间处理
export function getYYYYMMDD (str) {
  const nDate = new Date(str);
  const nYear = nDate.getFullYear();
  const nMonth = nDate.getMonth() + 1;
  const nDay = nDate.getDate();
  const nHours = nDate.getHours();
  const nMinutes = nDate.getMinutes();
  const nSeconds = nDate.getSeconds();
  const nTime = nYear + '-' + addZero(nMonth) + '-' + addZero(nDay); // YYYY-MM-DD
  const nDateTime = nTime + ' ' + addZero(nHours) + ':' + addZero(nMinutes) + ':' + addZero(nSeconds); // YYYY-MM-DD-MM-SS
  const YRSFM = addZero(nMonth) + '-' + addZero(nDay) + ' ' + addZero(nHours) + ':' + addZero(nMinutes) + ':' + addZero(nSeconds); // MM-DD-HH-MM
  const monthDay = addZero(nMonth) + '-' + addZero(nDay); // MM-DD 月日
  const hoursMinutes = addZero(nHours) + ':' + addZero(nMinutes); // MM-SS  时分
  const noSs = nTime + ' ' + hoursMinutes; // MM-SS  时分
  return {
    nYear: nYear + '', // 格式为 YYYY
    nMonth: addZero(nMonth), // 月
    nTime: nTime, // 格式为 YYYY-MM-DD
    nDateTime: nDateTime, // 格式为 YYYY-MM-DD-HH-MM-SS
    YRSFM: YRSFM, // 格式为MM-DD-HH-MM
    monthDay: monthDay, // 格式为MM-DD 月日
    hoursMinutes: hoursMinutes, // MM-SS  时分
    noSs: noSs // 不显示秒
  };
}

// 补齐时间 0
function addZero (num) {
  if (parseInt(num) < 10) {
    num = '0' + num;
  }
  return num;
}

// 数组对象查询
export function arrayQuery (val, list, findKey) {
  return list.find(item => {
    return item[findKey] === val;
  });
}

// 判断两个数组中是否有重复项
export function isShowColumn (originalArr, compareList) {
  return originalArr.some(item => {
    if (compareList.length > 0) {
      return compareList.indexOf(item) >= 0;
    } else {
      return false;
    }
  });
}

export function isExternal (path) {
  return /^(http?:|https?:|mailto:|tel:)/.test(path);
}

// 数组对象去重
export function arrRemoveDuplication (arr, key) {
  let map = new Map();
  for (let item of arr) {
    if (!map.has(item[key])) {
      map.set(item[key], item);
    }
  }
  return [...map.values()];
}

/**
 * 非空元素判断
 * @global
 * @function
 * @alias 工具类-判空 isNotEmpty
 * @param {*} somebody Object/Array/String
 * @returns {Boolean} 函数返回布尔值
 */
export const isNotEmpty = (obj) => {
  if (obj === undefined || obj === null) {
    return false;
  } else if (typeof obj === 'string') {
    return obj.trim().length !== 0;
  } else if (Array.isArray(obj)) {
    return obj.length !== 0;
  } else if (typeof obj === 'object') {
    return Object.keys(obj).length !== 0;
  } else {
    return true;
  }
};

/* 防止多次点击 */
export function throttle (fn, gapTime) {
  if (gapTime === null || gapTime === undefined) {
    gapTime = 1500;
  }
  let _lastTime = null;
  // 返回新的函数
  return function () {
    let _nowTime = +new Date();
    if (_nowTime - _lastTime > gapTime || !_lastTime) {
      fn.apply(this, arguments); // 将this和参数传给原函数
      _lastTime = _nowTime;
    }
  };
}

/* 防止多次点击 */
export function throttleAsync (fn, gapTime = 1500) {
  let lastTime = null;
  let pending = false;

  return async function () {
    const now = Date.now();

    if (pending) return;

    if (!lastTime || now - lastTime > gapTime) {
      pending = true;
      try {
        await fn.apply(this, arguments);
        lastTime = now;
      } finally {
        pending = false;
      }
    }
  };
}

// 获取url参数
export function getQueryParam (param) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}
/**
 * 获取ticket
 */
export const getTicket = () => {
  const ticket = Cookies.get('union_session_ticket');
  if (ticket) { return ticket; } else { return false; }
};
export const getAsTicket = (param) => {
  const ticket = Cookies.get(param);
  if (ticket) { return ticket; } else { return false; }
};
export function setCookie (name, value, days) {
  let expires = '';
  if (days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

export const setTicket = (key, value) => {
  if (value) {
    Cookies.set(key, value, { expires: 7 });
  } else {
    Cookies.remove(key);
  }
};

export const allPropsHaveValue = (obj) => {
  if (!obj || typeof obj !== 'object') return false;
  return Object.values(obj).every(v => v !== null && v !== undefined && v !== '');
};

// 数值四舍五入并保留指定位小数
export const roundToDecimals = (value, decimals = 0) => {
  const number = Number(value);
  if (!Number.isFinite(number)) {
    return number;
  }
  const precision = Math.min(20, Math.max(0, Math.trunc(decimals)));
  const factor = Math.pow(10, precision);
  const rounded = Math.round((number + Number.EPSILON) * factor) / factor;
  return Number(rounded.toFixed(precision));
};
